import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { FaReact } from 'react-icons/fa';
import {
  SiNodedotjs,
  SiMongodb,
  SiNextdotjs,
  SiFirebase,
  SiTailwindcss
} from 'react-icons/si';
import FeaturedProjectCard from './ProjectCard';
import { ProjectContext } from '../Admin/ProjectContext';

const FeaturedProjects = () => {
  const { projects, loading, error } = useContext(ProjectContext);
  const [hoveredCard, setHoveredCard] = useState(null);

  const featuredProjects = projects
    .filter((project) => project.is_featured)
    .map((project) => ({
      title: project.title || 'Untitled Project',
      description: project.description || [],
      tech: project.tech_stack?.join(' / ') || 'No technologies specified',
      logo: project.logo || 'https://upload.wikimedia.org/wikipedia/commons/a/a3/Image-not-found.png', // Fallback image
    logo_background: project.logo_background,
      link: `/projects/${project.id}`,
      preview: project.video || null, // Added
    }));

  const TECH_BGCOLORS = {
    React: "bg-[#232730]",
    "Node.js": "bg-[#0e121d]",
    MongoDB: "bg-[#011e2c]",
    "Next.js": "bg-[#000000]",
    Firebase: "bg-[#252525]",
    Tailwind: "bg-[#030712]",
  };

  const TECH_TEXTCOLORS = {
    React: "text-[#57c4db]",
    "Node.js": "text-[#417e38]",
    MongoDB: "text-[#01ed64]",
    "Next.js": "text-[#ffffff]",
    Firebase: "text-[#fe8f00]",
    Tailwind: "text-[#00bbfe]",
  };

  const TECH_ICONS = {
    React: FaReact,
    "Node.js": SiNodedotjs,
    MongoDB: SiMongodb,
    "Next.js": SiNextdotjs,
    Firebase: SiFirebase,
    Tailwind: SiTailwindcss,
  };

  if (loading) {
    return (
      <section id="projects" className="py-20 bg-white px-6 md:px-10">
        <div className="max-w-7xl mx-auto text-center">
          <p className="text-gray-600 text-lg">Loading featured projects...</p>
        </div>
      </section>
    );
  }

  if (error) {
    return (
      <section id="projects" className="py-20 bg-white px-6 md:px-10">
        <div className="max-w-7xl mx-auto text-center">
          <p className="text-red-600 text-lg">Error: {error}</p>
        </div>
      </section>
    );
  }

  return (
    <section id="projects" className="py-20 bg-white px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-4xl md:text-5xl font-light text-gray-900 text-center mb-20">
          Featured Projects
        </h2>

        {featuredProjects.length === 0 ? (
          <p className="text-center text-gray-600 text-lg">No featured projects available.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
            {featuredProjects.map((project, index) => (
              <FeaturedProjectCard
                key={project.id || index}
                project={project}
                isHovered={hoveredCard === index}
                onHover={(state) => setHoveredCard(state ? index : null)}
                TECH_ICONS={TECH_ICONS}
                TECH_BGCOLORS={TECH_BGCOLORS}
                TECH_TEXTCOLORS={TECH_TEXTCOLORS}
              />
            ))}
          </div>
        )}

        <div className="flex justify-center mt-14">
          <Link to="/projects" className="group">
            <button className="flex items-center gap-3 px-8 py-3 border border-gray-700 text-gray-800 rounded hover:bg-gray-800 hover:text-white transition-all">
              <span className="font-medium text-lg">View All Projects</span>
              <svg
                className="w-6 h-6 group-hover:translate-x-1 transition-transform duration-300"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M17 8l4 4m0 0l-4 4m4-4H3"
                />
              </svg>
            </button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProjects;